import type { Suggestion } from '@/features/search-bar/types';
import {
    getSuggestionLabel,
    getSuggestionSubtitle,
} from '@/features/search-bar/utils';
import Icon from '@/icons/icon';

export function SuggestionItem({
    s,
    onClick,
}: {
    s: Suggestion;
    onClick: () => void;
}) {
    return (
        <li
            onClick={onClick}
            className="flex cursor-pointer items-start gap-3 border-b border-gray-100 px-3 py-2 text-sm transition hover:bg-gray-50"
        >
            <Icon
                iconName="Location"
                className="mt-1 h-4 w-4 shrink-0 fill-gray-400"
            />
            <div className="min-w-0 flex-1">
                <div className="font-medium text-gray-900">{s.name}</div>
                <div className="text-xs text-gray-500">
                    {getSuggestionSubtitle(s)}
                </div>
            </div>
            <span className="shrink-0 rounded-full bg-gray-100 px-2 py-1 text-xs text-gray-600">
                {getSuggestionLabel(s)}
            </span>
        </li>
    );
}
